import * as actionTypes from './actionTypes';

interface State {
  data: any;
  isFetching: boolean;
  error: boolean;
}

const initialState: State = {
  data: {},
  isFetching: false,
  error: false
}

export const account = (state: State = initialState, action) => {
  switch(action.type) {
    case actionTypes.HASH_ACCOUNT_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.HASH_ACCOUNT_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.HASH_ACCOUNT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      }
    default:
      return state;
  }
}
